'use strict';

exports.__esModule = true;

var _CloseButton = require('./CloseButton');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloseButton).default;
  }
});
Object.defineProperty(exports, 'CLOSE_BUTTON_TONES', {
  enumerable: true,
  get: function get() {
    return _CloseButton.CLOSE_BUTTON_TONES;
  }
});

var _CloseButtonStyled = require('./CloseButtonStyled');

Object.defineProperty(exports, 'CloseButtonStyled', {
  enumerable: true,
  get: function get() {
    return _CloseButtonStyled.CloseButtonStyled;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }